export enum MediaRecordStatus {
  INIT = 0,
  RECORDING = 1,
  FINISHED = 2,
  UPLOADED = 3,
  CONVERTING = 4
}
